import { render } from "./CZLastBillDateElec.vue?vue&type=template&id=a56acfce&ts=true"
import script from "./CZLastBillDateElec.vue?vue&type=script&lang=ts"
export * from "./CZLastBillDateElec.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\WorkSpace\\Codebase\\CZone\\EICPartnershipSVN\\UI_EICPartnership\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__